class SignInPresenter {
  constructor(view, signInUseCase) {
    this.view = view;
    this.signInUseCase = signInUseCase;
  }

  submit({ email, password }) {
    const masterKey = "43600a5f650ed69e3391ccdf271332d437f4026e";
    const user = {
      username: email,
      password,
      masterKey,
    };
    this.view.showProgress();
    Promise.resolve()
      .then(() => this.signInUseCase.execute(user))
      .then((user) => {
        this.view.navigateTo("/");
      })
      .catch((error) => {
        this.view.hideProgress();
        this.view.showError(error);
      });
  }
}

export default SignInPresenter;
